import { LangStore } from '@/shared/model/store'
import Delegate from './delegate'
import GovernanceList from './governance-list'
import { useState } from 'react'
import { UserCard, UserStore } from '@/entities/user'
import { Button, Card, CardContent } from '@/shared/ui'
import NpoModal from '@/widgets/post-editor/ui/npo-modal'
import { IUser } from '@/entities/user/model/types'

export const Governance = () => {
	const { langPack } = LangStore()
	const { userData, user_npos } = UserStore()
	const [currentUser, setCurrentUser] = useState<`0x${string}`>(userData?.address || ('' as `0x${string}`))

	const isMy = Boolean(currentUser === userData?.address && userData.address)
	const current = user_npos?.find(user => user.address === currentUser) || userData || ({} as IUser)

	return (
		<div className='container rounded-md border p-6'>
			<h1 className='my-10 scroll-m-20 text-center text-4xl font-extrabold tracking-tight lg:text-5xl'>
				{langPack('governance.title')}
			</h1>
			{user_npos?.length && (
				<Card className='mb-5 items-center bg-background pt-5'>
					<CardContent className='flex flex-row items-center justify-between'>
						<UserCard user={current} length={100} />
						<div className='flex flex-row gap-4'>
							<Button
								onClick={() => setCurrentUser(userData?.address || ('' as `0x${string}`))}
								variant={'outline'}
								disabled={isMy}
							>
								{langPack('action.clear')}
							</Button>
							<NpoModal reg={setCurrentUser} closeAfterClick button={langPack('npo.selectNpo')} />
						</div>
					</CardContent>
				</Card>
			)}
			<Delegate current={current} />
			<GovernanceList current={current} />
		</div>
	)
}
